import classNames from 'classnames/bind'
import emojiPath from 'emojis/emojis.svg'

import * as styles from './index.vanilla.css'

type Sizes = 'small' | 'short' | 'medium' | 'big'
interface Props {
  name: string
  size?: Sizes
}

const cx = classNames.bind(styles)

export default function Emoji({ name, size }: Props) {
  return (
    <svg aria-hidden="true" className={cx('emoji', size ?? 'medium')}>
      <use xlinkHref={`${emojiPath}#icon-${name}`} />
    </svg>
  )
}
